import React, { ComponentType, FC, useMemo } from 'react';
import type { GroupBase, OptionProps, StylesConfig } from 'react-select';

import styled from 'styled-components';

// constants
import aampeTheme from '../../constants/aampeTheme';

import { VariantTypeOption } from '../../editors/PushNotificationEditor/Sidebar/VariantTypeDropdown';

import useComponentTypesQuery from '../../hooks/component-types/useComponentTypesQuery';

// components
import SearchableSelect, {
    SearchableSelectType,
} from '../inputs/searchableSelect';

interface DropdownProps {
    handleChange: (name: string, value: SearchableSelectType) => void;
    options: SearchableSelectType[];
    selected?: SearchableSelectType;
    isDisabled?: boolean;
    label?: string;
    labelStyle?: React.CSSProperties;
    placeholder?: string;
}

const VariantTypeDropdown: FC<React.PropsWithChildren<DropdownProps>> = ({
    handleChange,
    options,
    selected,
    isDisabled = false,
    label,
    labelStyle,
    placeholder,
}) => {
    const { data } = useComponentTypesQuery();

    const customStyles: StylesConfig<
        SearchableSelectType,
        boolean,
        GroupBase<SearchableSelectType>
    > = useMemo(
        () => ({
            singleValue: (provided, state) => ({
                ...provided,
                color: data?.map[(state.data as any).value]?.base_color,
            }),
            option: (provided, state) => ({
                ...provided,
                cursor: 'pointer',
                color: data?.map[(state.data as any).value]?.base_color,
                backgroundColor:
                    state.isFocused || state.isSelected
                        ? aampeTheme.colors.backgroundWG01
                        : aampeTheme.colors.white,
                padding: aampeTheme.spacing(1, 2),
            }),
        }),
        [data],
    );

    return (
        <VariantDropdown>
            <SearchableSelect
                placeholder={placeholder}
                label={label}
                labelStyle={labelStyle}
                name={'variant_type'}
                options={options}
                value={selected}
                onChange={(name, value) =>
                    handleChange(name, value as SearchableSelectType)
                }
                customStyles={customStyles}
                isDisabled={isDisabled}
                components={{
                    Option: VariantTypeOption as ComponentType<
                        React.PropsWithChildren<
                            OptionProps<
                                SearchableSelectType,
                                boolean,
                                GroupBase<SearchableSelectType>
                            >
                        >
                    >,
                }}
            />
        </VariantDropdown>
    );
};

export default VariantTypeDropdown;

const VariantDropdown = styled.div(() => ({
    minWidth: '200px',
}));
